﻿import Dialogs from '/src/common/dialogs/dialogs'
import AuthPad from '/src/common/auth/auth.vue'
import { parseISO, compareAsc } from 'date-fns'

export const useAuthStore = defineStore('auth', () => {
    const Auth = ref(null);

    function IsAuthValid(user) {
        if (!Auth.value) return false;
        if (user) {
            var users = user.split(';');
            if (!users.includes(Auth.value.user)) return false;
        }
        const d = parseISO(Auth.value.expires);
        const n = new Date();
        const v = compareAsc(d, n) == 1 ? true: false;
        return v;
    }

    function LogOut() {
        Auth.value = null;
    }

    async function Validate(user) {
        return new Promise((resolve, reject) => {
            if (user && IsAuthValid(user)) {
                resolve(true);
            }

            else {
                Dialogs
                    .Open(AuthPad, {section:user})
                    .onCancel(() => {
                        resolve(false);
                    })
                    .onOk(result => {
                        Auth.value = result;
                        resolve(true);
                    });
            }
        });


        return promise;
    }

    return { Auth, IsAuthValid, LogOut, Validate }
}, {
    persist: {
        key: 'ksm.auth',
        storage: window.sessionStorage,
    },
})